import React from "react";
import {
  Destination,
  DestinationValidation,
} from "../../../../application/domain/proc-management";
import { DestinationInput } from "./destination-input";
import { ListInput } from "./list-input";
import { InputProps, PathProps } from "./types";

const notices = ["ユーザーが、申請書などを送り届ける先を記述します。"];

type Props = InputProps &
  PathProps & {
    value: Destination[];
    validationErrors: DestinationValidation[];
  };

export const ProcedureByMailInfoDestinationsListInput: React.FC<Props> = ({
  value,
  onChange,
  disabled = false,
  basePath,
  shouldDisplayError,
  validationErrors,
}) => {
  return (
    <ListInput
      label="郵送先住所"
      required
      component={DestinationInput}
      componentProps={value.map((dest, i) => ({
        ...dest,
        onChange,
        shouldDisplayError,
        validationErrors: validationErrors[i],
      }))}
      basePath={basePath}
      onPush={() => {
        onChange(basePath, [
          ...value,
          {
            countryCode: "81", // JP as default
            postalCode: "",
            address1: "",
            address2: "",
            name: "",
          },
        ]);
      }}
      onRemove={(i) => {
        onChange(basePath, [...value.slice(0, i), ...value.slice(i + 1)]);
      }}
      disabled={disabled}
      notices={notices}
    />
  );
};
